export const THEME_ID_STORAGE_KEY = 'themeId';
export const THEME_FAMILY_STORAGE_KEY = 'theme';
export const THEME_ACCENT_OVERRIDES_STORAGE_KEY = 'themeAccentOverrides';
export const THEME_BACKGROUND_OVERRIDES_STORAGE_KEY = 'themeBackgroundOverrides';
export const THEME_TEXT_OVERRIDES_STORAGE_KEY = 'themeTextOverrides';

const THEME_DEFINITIONS = [
  {
    id: 'light',
    label: 'Light',
    family: 'light',
    tags: [],
    description: 'The current clean default light mode.',
    tokens: {
      bg: '#FAFAFA',
      surface: '#FFFFFF',
      surface2: '#F3F4F6',
      surfaceRaised: '#FFFFFF',
      text: '#111827',
      textMuted: '#6B7280',
      border: '#E5E7EB',
      inputBg: '#FFFFFF',
      accent: '#3B82F6',
      accentHover: '#2563EB',
      accentSoft: 'rgba(59, 130, 246, 0.12)',
      success: '#10B981',
      successSoft: 'rgba(16, 185, 129, 0.14)',
      loss: '#EF4444',
      lossSoft: 'rgba(239, 68, 68, 0.14)',
      breakEven: '#3B82F6',
      breakEvenSoft: 'rgba(59, 130, 246, 0.12)',
      chartPrimary: '#3B82F6',
      chartDot: '#60A5FA',
      chartGradientStart: 'rgba(59, 130, 246, 0.25)',
      chartGradientEnd: 'rgba(59, 130, 246, 0.02)',
      chartGrid: '#E5E7EB',
      chartTooltipBg: '#FFFFFF',
      scrollbarTrack: '#E5E7EB',
      scrollbarThumb: '#9CA3AF',
      shadow: 'rgba(15, 23, 42, 0.08)',
      selection: 'rgba(59, 130, 246, 0.24)',
    },
  },
  {
    id: 'dark',
    label: 'Dark',
    family: 'dark',
    tags: [],
    description: 'The current blue-tinted default dark mode.',
    tokens: {
      bg: '#111827',
      surface: '#1F2937',
      surface2: '#374151',
      surfaceRaised: '#0F172A',
      text: '#F9FAFB',
      textMuted: '#9CA3AF',
      border: '#374151',
      inputBg: '#1F2937',
      accent: '#60A5FA',
      accentHover: '#3B82F6',
      accentSoft: 'rgba(96, 165, 250, 0.18)',
      success: '#10F981',
      successSoft: 'rgba(16, 249, 129, 0.16)',
      loss: '#FF6B6B',
      lossSoft: 'rgba(255, 107, 107, 0.16)',
      breakEven: '#60A5FA',
      breakEvenSoft: 'rgba(96, 165, 250, 0.18)',
      chartPrimary: '#60A5FA',
      chartDot: '#93C5FD',
      chartGradientStart: 'rgba(96, 165, 250, 0.3)',
      chartGradientEnd: 'rgba(96, 165, 250, 0.05)',
      chartGrid: '#374151',
      chartTooltipBg: '#1F2937',
      scrollbarTrack: '#374151',
      scrollbarThumb: '#6B7280',
      shadow: 'rgba(15, 23, 42, 0.42)',
      selection: 'rgba(96, 165, 250, 0.28)',
    },
  },
  {
    id: 'paper',
    label: 'Paper',
    family: 'light',
    tags: [],
    description: 'Soft white with a classic editorial feel.',
    tokens: {
      bg: '#F8F6F0',
      surface: '#FFFDF8',
      surface2: '#F0EBDF',
      surfaceRaised: '#FFFFFF',
      text: '#1F2937',
      textMuted: '#6B7280',
      border: '#E5DED2',
      inputBg: '#FFFDF8',
      accent: '#2563EB',
      accentHover: '#1D4ED8',
      accentSoft: 'rgba(37, 99, 235, 0.12)',
      success: '#059669',
      successSoft: 'rgba(5, 150, 105, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#2563EB',
      breakEvenSoft: 'rgba(37, 99, 235, 0.12)',
      chartPrimary: '#2563EB',
      chartDot: '#60A5FA',
      chartGradientStart: 'rgba(37, 99, 235, 0.2)',
      chartGradientEnd: 'rgba(37, 99, 235, 0.03)',
      chartGrid: '#E5DED2',
      chartTooltipBg: '#FFFDF8',
      scrollbarTrack: '#ECE5D8',
      scrollbarThumb: '#A8A29E',
      shadow: 'rgba(71, 85, 105, 0.12)',
      selection: 'rgba(37, 99, 235, 0.22)',
    },
  },
  {
    id: 'ice',
    label: 'Ice',
    family: 'light',
    tags: [],
    description: 'Cool light surfaces with a crisp blue edge.',
    tokens: {
      bg: '#F3F8FC',
      surface: '#FFFFFF',
      surface2: '#E6F0F7',
      surfaceRaised: '#FFFFFF',
      text: '#0F172A',
      textMuted: '#64748B',
      border: '#D8E3EE',
      inputBg: '#F8FBFF',
      accent: '#0EA5E9',
      accentHover: '#0284C7',
      accentSoft: 'rgba(14, 165, 233, 0.14)',
      success: '#0F766E',
      successSoft: 'rgba(15, 118, 110, 0.14)',
      loss: '#E11D48',
      lossSoft: 'rgba(225, 29, 72, 0.12)',
      breakEven: '#2563EB',
      breakEvenSoft: 'rgba(37, 99, 235, 0.12)',
      chartPrimary: '#0EA5E9',
      chartDot: '#38BDF8',
      chartGradientStart: 'rgba(14, 165, 233, 0.22)',
      chartGradientEnd: 'rgba(14, 165, 233, 0.03)',
      chartGrid: '#D8E3EE',
      chartTooltipBg: '#FFFFFF',
      scrollbarTrack: '#E2E8F0',
      scrollbarThumb: '#94A3B8',
      shadow: 'rgba(14, 165, 233, 0.1)',
      selection: 'rgba(14, 165, 233, 0.22)',
    },
  },
  {
    id: 'rose-light',
    label: 'Rose Light',
    family: 'light',
    tags: [],
    description: 'Warm light surfaces with soft rose accents.',
    tokens: {
      bg: '#FFF7F8',
      surface: '#FFFFFF',
      surface2: '#FDECEF',
      surfaceRaised: '#FFFFFF',
      text: '#312E34',
      textMuted: '#7C6D74',
      border: '#F0D9DE',
      inputBg: '#FFF9FA',
      accent: '#E11D48',
      accentHover: '#BE123C',
      accentSoft: 'rgba(225, 29, 72, 0.12)',
      success: '#059669',
      successSoft: 'rgba(5, 150, 105, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#7C3AED',
      breakEvenSoft: 'rgba(124, 58, 237, 0.12)',
      chartPrimary: '#E11D48',
      chartDot: '#FB7185',
      chartGradientStart: 'rgba(225, 29, 72, 0.2)',
      chartGradientEnd: 'rgba(225, 29, 72, 0.03)',
      chartGrid: '#F0D9DE',
      chartTooltipBg: '#FFFFFF',
      scrollbarTrack: '#F5E4E8',
      scrollbarThumb: '#C08497',
      shadow: 'rgba(225, 29, 72, 0.08)',
      selection: 'rgba(225, 29, 72, 0.22)',
    },
  },
  {
    id: 'sand',
    label: 'Sand',
    family: 'light',
    tags: [],
    description: 'Warm beige surfaces with amber highlights.',
    tokens: {
      bg: '#F7F1E8',
      surface: '#FFF9F0',
      surface2: '#EFE2CF',
      surfaceRaised: '#FFFDF8',
      text: '#2F241B',
      textMuted: '#7A6A5A',
      border: '#E3D3BE',
      inputBg: '#FFF8ED',
      accent: '#D97706',
      accentHover: '#B45309',
      accentSoft: 'rgba(217, 119, 6, 0.14)',
      success: '#15803D',
      successSoft: 'rgba(21, 128, 61, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#2563EB',
      breakEvenSoft: 'rgba(37, 99, 235, 0.12)',
      chartPrimary: '#D97706',
      chartDot: '#F59E0B',
      chartGradientStart: 'rgba(217, 119, 6, 0.2)',
      chartGradientEnd: 'rgba(217, 119, 6, 0.03)',
      chartGrid: '#E3D3BE',
      chartTooltipBg: '#FFF9F0',
      scrollbarTrack: '#EDE0D0',
      scrollbarThumb: '#B08968',
      shadow: 'rgba(146, 64, 14, 0.12)',
      selection: 'rgba(217, 119, 6, 0.2)',
    },
  },
  {
    id: 'mint-light',
    label: 'Mint Light',
    family: 'light',
    tags: [],
    description: 'Fresh mint surfaces with soft green accents.',
    tokens: {
      bg: '#F2FBF8',
      surface: '#FFFFFF',
      surface2: '#E3F5EE',
      surfaceRaised: '#FFFFFF',
      text: '#12302A',
      textMuted: '#5B7D76',
      border: '#CFE8E0',
      inputBg: '#F7FDFA',
      accent: '#10B981',
      accentHover: '#059669',
      accentSoft: 'rgba(16, 185, 129, 0.14)',
      success: '#059669',
      successSoft: 'rgba(5, 150, 105, 0.14)',
      loss: '#EF4444',
      lossSoft: 'rgba(239, 68, 68, 0.12)',
      breakEven: '#0EA5E9',
      breakEvenSoft: 'rgba(14, 165, 233, 0.12)',
      chartPrimary: '#10B981',
      chartDot: '#34D399',
      chartGradientStart: 'rgba(16, 185, 129, 0.2)',
      chartGradientEnd: 'rgba(16, 185, 129, 0.03)',
      chartGrid: '#CFE8E0',
      chartTooltipBg: '#FFFFFF',
      scrollbarTrack: '#DDEEE7',
      scrollbarThumb: '#86B6AA',
      shadow: 'rgba(16, 185, 129, 0.1)',
      selection: 'rgba(16, 185, 129, 0.2)',
    },
  },
  {
    id: 'alabaster',
    label: 'Alabaster',
    family: 'light',
    tags: ['minimal'],
    description: 'Quiet ivory surfaces with slate accents and a gallery-like calm.',
    tokens: {
      bg: '#F6F4EF',
      surface: '#FFFDFC',
      surface2: '#ECE8DE',
      surfaceRaised: '#FFFFFF',
      text: '#1F2933',
      textMuted: '#6B7280',
      border: '#DDD6C8',
      inputBg: '#FFFDFC',
      accent: '#475569',
      accentHover: '#334155',
      accentSoft: 'rgba(71, 85, 105, 0.12)',
      success: '#15803D',
      successSoft: 'rgba(21, 128, 61, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#475569',
      breakEvenSoft: 'rgba(71, 85, 105, 0.12)',
      chartPrimary: '#475569',
      chartDot: '#64748B',
      chartGradientStart: 'rgba(71, 85, 105, 0.22)',
      chartGradientEnd: 'rgba(71, 85, 105, 0.03)',
      chartGrid: '#DDD6C8',
      chartTooltipBg: '#FFFDFC',
      scrollbarTrack: '#E9E2D5',
      scrollbarThumb: '#9CA3AF',
      shadow: 'rgba(51, 65, 85, 0.12)',
      selection: 'rgba(71, 85, 105, 0.2)',
    },
  },
  {
    id: 'linen',
    label: 'Linen',
    family: 'light',
    tags: ['minimal'],
    description: 'Warm parchment neutrals with a refined bronze accent.',
    tokens: {
      bg: '#FBF7F1',
      surface: '#FFFDFC',
      surface2: '#F1E7D9',
      surfaceRaised: '#FFFFFF',
      text: '#2B2118',
      textMuted: '#7B6B5A',
      border: '#E6D7C4',
      inputBg: '#FFF9F2',
      accent: '#9A6B3A',
      accentHover: '#7C5530',
      accentSoft: 'rgba(154, 107, 58, 0.13)',
      success: '#15803D',
      successSoft: 'rgba(21, 128, 61, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#9A6B3A',
      breakEvenSoft: 'rgba(154, 107, 58, 0.13)',
      chartPrimary: '#9A6B3A',
      chartDot: '#C08457',
      chartGradientStart: 'rgba(154, 107, 58, 0.22)',
      chartGradientEnd: 'rgba(154, 107, 58, 0.03)',
      chartGrid: '#E6D7C4',
      chartTooltipBg: '#FFFDFC',
      scrollbarTrack: '#EFE2D2',
      scrollbarThumb: '#B08968',
      shadow: 'rgba(124, 85, 48, 0.12)',
      selection: 'rgba(154, 107, 58, 0.2)',
    },
  },
  {
    id: 'sage-ledger',
    label: 'Sage Ledger',
    family: 'light',
    tags: ['minimal'],
    description: 'Muted green accounting-book tones with soft contrast.',
    tokens: {
      bg: '#F2F6F0',
      surface: '#FCFFFB',
      surface2: '#E3ECE2',
      surfaceRaised: '#FFFFFF',
      text: '#183128',
      textMuted: '#5F766E',
      border: '#CFDCCF',
      inputBg: '#F8FCF7',
      accent: '#4F7A62',
      accentHover: '#3E624F',
      accentSoft: 'rgba(79, 122, 98, 0.13)',
      success: '#15803D',
      successSoft: 'rgba(21, 128, 61, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#4F7A62',
      breakEvenSoft: 'rgba(79, 122, 98, 0.13)',
      chartPrimary: '#4F7A62',
      chartDot: '#6C9A7E',
      chartGradientStart: 'rgba(79, 122, 98, 0.22)',
      chartGradientEnd: 'rgba(79, 122, 98, 0.03)',
      chartGrid: '#CFDCCF',
      chartTooltipBg: '#FCFFFB',
      scrollbarTrack: '#DFE9DF',
      scrollbarThumb: '#8AA395',
      shadow: 'rgba(79, 122, 98, 0.1)',
      selection: 'rgba(79, 122, 98, 0.2)',
    },
  },
  {
    id: 'volt',
    label: 'Volt',
    family: 'light',
    tags: ['neon'],
    description: 'A pale studio-white theme energized with electric lime.',
    tokens: {
      bg: '#F8FFF2',
      surface: '#FFFFFF',
      surface2: '#ECFDD3',
      surfaceRaised: '#FFFFFF',
      text: '#13210F',
      textMuted: '#52715D',
      border: '#D9EBAA',
      inputBg: '#FCFFF7',
      accent: '#84CC16',
      accentHover: '#65A30D',
      accentSoft: 'rgba(132, 204, 22, 0.16)',
      success: '#16A34A',
      successSoft: 'rgba(22, 163, 74, 0.14)',
      loss: '#E11D48',
      lossSoft: 'rgba(225, 29, 72, 0.12)',
      breakEven: '#84CC16',
      breakEvenSoft: 'rgba(132, 204, 22, 0.16)',
      chartPrimary: '#84CC16',
      chartDot: '#A3E635',
      chartGradientStart: 'rgba(132, 204, 22, 0.26)',
      chartGradientEnd: 'rgba(132, 204, 22, 0.04)',
      chartGrid: '#D9EBAA',
      chartTooltipBg: '#FFFFFF',
      scrollbarTrack: '#E5F2BE',
      scrollbarThumb: '#A3A34A',
      shadow: 'rgba(132, 204, 22, 0.14)',
      selection: 'rgba(132, 204, 22, 0.22)',
    },
  },
  {
    id: 'sunset-pop',
    label: 'Sunset Pop',
    family: 'light',
    tags: ['vibrant'],
    description: 'Creamy daylight neutrals with a punchy tangerine accent.',
    tokens: {
      bg: '#FFF6EE',
      surface: '#FFFDFC',
      surface2: '#FFE7D6',
      surfaceRaised: '#FFFFFF',
      text: '#2E1E15',
      textMuted: '#7D6658',
      border: '#F0D0BA',
      inputBg: '#FFF9F5',
      accent: '#F97316',
      accentHover: '#EA580C',
      accentSoft: 'rgba(249, 115, 22, 0.14)',
      success: '#16A34A',
      successSoft: 'rgba(22, 163, 74, 0.14)',
      loss: '#E11D48',
      lossSoft: 'rgba(225, 29, 72, 0.12)',
      breakEven: '#0EA5E9',
      breakEvenSoft: 'rgba(14, 165, 233, 0.12)',
      chartPrimary: '#F97316',
      chartDot: '#FDBA74',
      chartGradientStart: 'rgba(249, 115, 22, 0.22)',
      chartGradientEnd: 'rgba(249, 115, 22, 0.03)',
      chartGrid: '#F0D0BA',
      chartTooltipBg: '#FFFDFC',
      scrollbarTrack: '#F6DDCC',
      scrollbarThumb: '#C48A6A',
      shadow: 'rgba(249, 115, 22, 0.1)',
      selection: 'rgba(249, 115, 22, 0.2)',
    },
  },
  {
    id: 'lagoon',
    label: 'Lagoon',
    family: 'light',
    tags: ['vibrant'],
    description: 'Sea-glass whites with a sharper teal trading-desk accent.',
    tokens: {
      bg: '#F2FBFA',
      surface: '#FFFFFF',
      surface2: '#DDF4F0',
      surfaceRaised: '#FFFFFF',
      text: '#0F2E2C',
      textMuted: '#5B7B78',
      border: '#C9E5DE',
      inputBg: '#F7FDFC',
      accent: '#0F766E',
      accentHover: '#0D5E58',
      accentSoft: 'rgba(15, 118, 110, 0.14)',
      success: '#059669',
      successSoft: 'rgba(5, 150, 105, 0.14)',
      loss: '#E11D48',
      lossSoft: 'rgba(225, 29, 72, 0.12)',
      breakEven: '#0891B2',
      breakEvenSoft: 'rgba(8, 145, 178, 0.12)',
      chartPrimary: '#0F766E',
      chartDot: '#2DD4BF',
      chartGradientStart: 'rgba(15, 118, 110, 0.22)',
      chartGradientEnd: 'rgba(15, 118, 110, 0.03)',
      chartGrid: '#C9E5DE',
      chartTooltipBg: '#FFFFFF',
      scrollbarTrack: '#D9EEE9',
      scrollbarThumb: '#7BA8A0',
      shadow: 'rgba(15, 118, 110, 0.1)',
      selection: 'rgba(15, 118, 110, 0.2)',
    },
  },
  {
    id: 'harbor-mist',
    label: 'Harbor Mist',
    family: 'light',
    tags: ['minimal'],
    description: 'Cool city-paper neutrals with a crisp royal-blue signal.',
    tokens: {
      bg: '#F4F7FB',
      surface: '#FFFFFF',
      surface2: '#E7EDF5',
      surfaceRaised: '#FFFFFF',
      text: '#1C2736',
      textMuted: '#64748B',
      border: '#D6DFEB',
      inputBg: '#FAFCFF',
      accent: '#4361EE',
      accentHover: '#3751CC',
      accentSoft: 'rgba(67, 97, 238, 0.12)',
      success: '#16A34A',
      successSoft: 'rgba(22, 163, 74, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#0891B2',
      breakEvenSoft: 'rgba(8, 145, 178, 0.12)',
      chartPrimary: '#4361EE',
      chartDot: '#7C93FF',
      chartGradientStart: 'rgba(67, 97, 238, 0.2)',
      chartGradientEnd: 'rgba(67, 97, 238, 0.03)',
      chartGrid: '#D6DFEB',
      chartTooltipBg: '#FFFFFF',
      scrollbarTrack: '#E2E8F0',
      scrollbarThumb: '#94A3B8',
      shadow: 'rgba(67, 97, 238, 0.08)',
      selection: 'rgba(67, 97, 238, 0.2)',
    },
  },
  {
    id: 'clay',
    label: 'Clay',
    family: 'light',
    tags: ['warm'],
    description: 'Terracotta notes over warm plaster surfaces with solid contrast.',
    tokens: {
      bg: '#F8F1EB',
      surface: '#FFF9F5',
      surface2: '#ECDDD0',
      surfaceRaised: '#FFFFFF',
      text: '#31211B',
      textMuted: '#7D675E',
      border: '#E2CDBF',
      inputBg: '#FFF8F2',
      accent: '#C2410C',
      accentHover: '#9A3412',
      accentSoft: 'rgba(194, 65, 12, 0.14)',
      success: '#15803D',
      successSoft: 'rgba(21, 128, 61, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#0369A1',
      breakEvenSoft: 'rgba(3, 105, 161, 0.12)',
      chartPrimary: '#C2410C',
      chartDot: '#F59E0B',
      chartGradientStart: 'rgba(194, 65, 12, 0.2)',
      chartGradientEnd: 'rgba(194, 65, 12, 0.03)',
      chartGrid: '#E2CDBF',
      chartTooltipBg: '#FFF9F5',
      scrollbarTrack: '#EEDFD4',
      scrollbarThumb: '#B08974',
      shadow: 'rgba(154, 52, 18, 0.1)',
      selection: 'rgba(194, 65, 12, 0.2)',
    },
  },
  {
    id: 'blueprint-light',
    label: 'Blueprint Light',
    family: 'light',
    tags: ['minimal'],
    description: 'Drafting-table whites with precise cobalt structure and clarity.',
    tokens: {
      bg: '#F4F8FC',
      surface: '#FFFFFF',
      surface2: '#E2ECF7',
      surfaceRaised: '#FFFFFF',
      text: '#172554',
      textMuted: '#5B6B84',
      border: '#CAD8E7',
      inputBg: '#F9FBFF',
      accent: '#2563EB',
      accentHover: '#1D4ED8',
      accentSoft: 'rgba(37, 99, 235, 0.13)',
      success: '#059669',
      successSoft: 'rgba(5, 150, 105, 0.14)',
      loss: '#DC2626',
      lossSoft: 'rgba(220, 38, 38, 0.12)',
      breakEven: '#0EA5E9',
      breakEvenSoft: 'rgba(14, 165, 233, 0.12)',
      chartPrimary: '#2563EB',
      chartDot: '#60A5FA',
      chartGradientStart: 'rgba(37, 99, 235, 0.2)',
      chartGradientEnd: 'rgba(37, 99, 235, 0.03)',
      chartGrid: '#CAD8E7',
      chartTooltipBg: '#FFFFFF',
      scrollbarTrack: '#DBE5EF',
      scrollbarThumb: '#8DA2B8',
      shadow: 'rgba(37, 99, 235, 0.08)',
      selection: 'rgba(37, 99, 235, 0.2)',
    },
  },
  {
    id: 'true-black',
    label: 'True Black',
    family: 'dark',
    tags: [],
    description: 'An actual black OLED-style dark theme.',
    tokens: {
      bg: '#000000',
      surface: '#090909',
      surface2: '#121212',
      surfaceRaised: '#161616',
      text: '#FAFAFA',
      textMuted: '#A3A3A3',
      border: '#262626',
      inputBg: '#0D0D0D',
      accent: '#38BDF8',
      accentHover: '#0EA5E9',
      accentSoft: 'rgba(56, 189, 248, 0.16)',
      success: '#22C55E',
      successSoft: 'rgba(34, 197, 94, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#60A5FA',
      breakEvenSoft: 'rgba(96, 165, 250, 0.16)',
      chartPrimary: '#38BDF8',
      chartDot: '#7DD3FC',
      chartGradientStart: 'rgba(56, 189, 248, 0.26)',
      chartGradientEnd: 'rgba(56, 189, 248, 0.04)',
      chartGrid: '#1F2937',
      chartTooltipBg: '#0A0A0A',
      scrollbarTrack: '#171717',
      scrollbarThumb: '#525252',
      shadow: 'rgba(0, 0, 0, 0.58)',
      selection: 'rgba(56, 189, 248, 0.28)',
    },
  },
  {
    id: 'midnight-blue',
    label: 'Midnight Blue',
    family: 'dark',
    tags: [],
    description: 'Deep navy with cool, crisp blue lighting.',
    tokens: {
      bg: '#08111F',
      surface: '#0F1B2D',
      surface2: '#16263C',
      surfaceRaised: '#112136',
      text: '#EAF2FF',
      textMuted: '#8CA3C4',
      border: '#24364E',
      inputBg: '#102036',
      accent: '#60A5FA',
      accentHover: '#3B82F6',
      accentSoft: 'rgba(96, 165, 250, 0.18)',
      success: '#34D399',
      successSoft: 'rgba(52, 211, 153, 0.16)',
      loss: '#F87171',
      lossSoft: 'rgba(248, 113, 113, 0.16)',
      breakEven: '#38BDF8',
      breakEvenSoft: 'rgba(56, 189, 248, 0.16)',
      chartPrimary: '#60A5FA',
      chartDot: '#93C5FD',
      chartGradientStart: 'rgba(96, 165, 250, 0.28)',
      chartGradientEnd: 'rgba(96, 165, 250, 0.05)',
      chartGrid: '#24364E',
      chartTooltipBg: '#0F1B2D',
      scrollbarTrack: '#18263B',
      scrollbarThumb: '#4B6284',
      shadow: 'rgba(8, 17, 31, 0.56)',
      selection: 'rgba(96, 165, 250, 0.28)',
    },
  },
  {
    id: 'crimson-night',
    label: 'Crimson Night',
    family: 'dark',
    tags: [],
    description: 'Dark charcoal with rich red accents.',
    tokens: {
      bg: '#120A0D',
      surface: '#1B1116',
      surface2: '#2A1820',
      surfaceRaised: '#24141B',
      text: '#FFF4F5',
      textMuted: '#C8AAB0',
      border: '#432430',
      inputBg: '#1E1118',
      accent: '#F43F5E',
      accentHover: '#E11D48',
      accentSoft: 'rgba(244, 63, 94, 0.18)',
      success: '#22C55E',
      successSoft: 'rgba(34, 197, 94, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#A855F7',
      breakEvenSoft: 'rgba(168, 85, 247, 0.16)',
      chartPrimary: '#F43F5E',
      chartDot: '#FB7185',
      chartGradientStart: 'rgba(244, 63, 94, 0.26)',
      chartGradientEnd: 'rgba(244, 63, 94, 0.05)',
      chartGrid: '#432430',
      chartTooltipBg: '#1B1116',
      scrollbarTrack: '#26161D',
      scrollbarThumb: '#7A4354',
      shadow: 'rgba(18, 10, 13, 0.58)',
      selection: 'rgba(244, 63, 94, 0.28)',
    },
  },
  {
    id: 'cobalt-dark',
    label: 'Cobalt Dark',
    family: 'dark',
    tags: [],
    description: 'A strong blue-forward dark theme.',
    tokens: {
      bg: '#0B1220',
      surface: '#131C2E',
      surface2: '#1D2A40',
      surfaceRaised: '#172338',
      text: '#F1F5F9',
      textMuted: '#9FB2C8',
      border: '#2B3B53',
      inputBg: '#121E31',
      accent: '#3B82F6',
      accentHover: '#2563EB',
      accentSoft: 'rgba(59, 130, 246, 0.18)',
      success: '#34D399',
      successSoft: 'rgba(52, 211, 153, 0.16)',
      loss: '#F87171',
      lossSoft: 'rgba(248, 113, 113, 0.16)',
      breakEven: '#60A5FA',
      breakEvenSoft: 'rgba(96, 165, 250, 0.16)',
      chartPrimary: '#3B82F6',
      chartDot: '#60A5FA',
      chartGradientStart: 'rgba(59, 130, 246, 0.26)',
      chartGradientEnd: 'rgba(59, 130, 246, 0.05)',
      chartGrid: '#2B3B53',
      chartTooltipBg: '#131C2E',
      scrollbarTrack: '#1A2940',
      scrollbarThumb: '#58779F',
      shadow: 'rgba(11, 18, 32, 0.56)',
      selection: 'rgba(59, 130, 246, 0.28)',
    },
  },
  {
    id: 'forest-dark',
    label: 'Forest Dark',
    family: 'dark',
    tags: [],
    description: 'A dark evergreen palette with natural contrast.',
    tokens: {
      bg: '#091510',
      surface: '#112019',
      surface2: '#193026',
      surfaceRaised: '#13271F',
      text: '#ECFDF5',
      textMuted: '#98B7A8',
      border: '#28473B',
      inputBg: '#10221A',
      accent: '#10B981',
      accentHover: '#059669',
      accentSoft: 'rgba(16, 185, 129, 0.18)',
      success: '#34D399',
      successSoft: 'rgba(52, 211, 153, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#2DD4BF',
      breakEvenSoft: 'rgba(45, 212, 191, 0.16)',
      chartPrimary: '#10B981',
      chartDot: '#34D399',
      chartGradientStart: 'rgba(16, 185, 129, 0.26)',
      chartGradientEnd: 'rgba(16, 185, 129, 0.05)',
      chartGrid: '#28473B',
      chartTooltipBg: '#112019',
      scrollbarTrack: '#173026',
      scrollbarThumb: '#4C7B69',
      shadow: 'rgba(9, 21, 16, 0.56)',
      selection: 'rgba(16, 185, 129, 0.28)',
    },
  },
  {
    id: 'inkstone',
    label: 'Inkstone',
    family: 'dark',
    tags: ['minimal'],
    description: 'Quiet charcoal layers with restrained blue-gray light.',
    tokens: {
      bg: '#0E131B',
      surface: '#151C26',
      surface2: '#1B2633',
      surfaceRaised: '#17212D',
      text: '#EEF2F7',
      textMuted: '#94A3B8',
      border: '#2B3646',
      inputBg: '#141E2A',
      accent: '#7C93B9',
      accentHover: '#64748B',
      accentSoft: 'rgba(124, 147, 185, 0.18)',
      success: '#34D399',
      successSoft: 'rgba(52, 211, 153, 0.16)',
      loss: '#F87171',
      lossSoft: 'rgba(248, 113, 113, 0.16)',
      breakEven: '#7C93B9',
      breakEvenSoft: 'rgba(124, 147, 185, 0.18)',
      chartPrimary: '#7C93B9',
      chartDot: '#A5B4CC',
      chartGradientStart: 'rgba(124, 147, 185, 0.28)',
      chartGradientEnd: 'rgba(124, 147, 185, 0.05)',
      chartGrid: '#2B3646',
      chartTooltipBg: '#151C26',
      scrollbarTrack: '#1D2835',
      scrollbarThumb: '#5B6B82',
      shadow: 'rgba(8, 12, 20, 0.58)',
      selection: 'rgba(124, 147, 185, 0.28)',
    },
  },
  {
    id: 'espresso',
    label: 'Espresso',
    family: 'dark',
    tags: ['minimal'],
    description: 'Dark roast browns with a polished café-gold accent.',
    tokens: {
      bg: '#140F0D',
      surface: '#1C1512',
      surface2: '#271D18',
      surfaceRaised: '#221915',
      text: '#F8F2EE',
      textMuted: '#B9A79B',
      border: '#3B2C24',
      inputBg: '#1A1411',
      accent: '#D4A373',
      accentHover: '#C08552',
      accentSoft: 'rgba(212, 163, 115, 0.18)',
      success: '#22C55E',
      successSoft: 'rgba(34, 197, 94, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#D4A373',
      breakEvenSoft: 'rgba(212, 163, 115, 0.18)',
      chartPrimary: '#D4A373',
      chartDot: '#E7BC8F',
      chartGradientStart: 'rgba(212, 163, 115, 0.28)',
      chartGradientEnd: 'rgba(212, 163, 115, 0.05)',
      chartGrid: '#3B2C24',
      chartTooltipBg: '#1C1512',
      scrollbarTrack: '#261C18',
      scrollbarThumb: '#8F6A55',
      shadow: 'rgba(20, 15, 13, 0.58)',
      selection: 'rgba(212, 163, 115, 0.28)',
    },
  },
  {
    id: 'steel-night',
    label: 'Steel Night',
    family: 'dark',
    tags: ['minimal'],
    description: 'Industrial blue-steel tones with a calm technical edge.',
    tokens: {
      bg: '#101722',
      surface: '#17202D',
      surface2: '#223041',
      surfaceRaised: '#1A2533',
      text: '#EAF0F7',
      textMuted: '#95A3B7',
      border: '#304255',
      inputBg: '#162230',
      accent: '#7AA2C4',
      accentHover: '#5F88AB',
      accentSoft: 'rgba(122, 162, 196, 0.18)',
      success: '#34D399',
      successSoft: 'rgba(52, 211, 153, 0.16)',
      loss: '#F87171',
      lossSoft: 'rgba(248, 113, 113, 0.16)',
      breakEven: '#7AA2C4',
      breakEvenSoft: 'rgba(122, 162, 196, 0.18)',
      chartPrimary: '#7AA2C4',
      chartDot: '#9CC0DC',
      chartGradientStart: 'rgba(122, 162, 196, 0.28)',
      chartGradientEnd: 'rgba(122, 162, 196, 0.05)',
      chartGrid: '#304255',
      chartTooltipBg: '#17202D',
      scrollbarTrack: '#1E2A38',
      scrollbarThumb: '#617C98',
      shadow: 'rgba(16, 23, 34, 0.58)',
      selection: 'rgba(122, 162, 196, 0.28)',
    },
  },
  {
    id: 'after-hours',
    label: 'After Hours',
    family: 'dark',
    tags: ['neon'],
    description: 'Late-session navy with luminous cyan and club-sign energy.',
    tokens: {
      bg: '#070B14',
      surface: '#0D1320',
      surface2: '#141C2E',
      surfaceRaised: '#11192A',
      text: '#F5FBFF',
      textMuted: '#9BB6D1',
      border: '#1F2E47',
      inputBg: '#0C1424',
      accent: '#22D3EE',
      accentHover: '#06B6D4',
      accentSoft: 'rgba(34, 211, 238, 0.2)',
      success: '#22C55E',
      successSoft: 'rgba(34, 197, 94, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#22D3EE',
      breakEvenSoft: 'rgba(34, 211, 238, 0.2)',
      chartPrimary: '#22D3EE',
      chartDot: '#67E8F9',
      chartGradientStart: 'rgba(34, 211, 238, 0.3)',
      chartGradientEnd: 'rgba(34, 211, 238, 0.05)',
      chartGrid: '#1F2E47',
      chartTooltipBg: '#0D1320',
      scrollbarTrack: '#152036',
      scrollbarThumb: '#3F6B96',
      shadow: 'rgba(7, 11, 20, 0.62)',
      selection: 'rgba(34, 211, 238, 0.3)',
    },
  },
  {
    id: 'neon-market',
    label: 'Neon Market',
    family: 'dark',
    tags: ['neon'],
    description: 'Black-glass trading terminal energy with acid-lime highlights.',
    tokens: {
      bg: '#05070A',
      surface: '#0B1016',
      surface2: '#111A24',
      surfaceRaised: '#0F1620',
      text: '#F4FFE9',
      textMuted: '#9EB593',
      border: '#243126',
      inputBg: '#0A1118',
      accent: '#A3E635',
      accentHover: '#84CC16',
      accentSoft: 'rgba(163, 230, 53, 0.2)',
      success: '#4ADE80',
      successSoft: 'rgba(74, 222, 128, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#22D3EE',
      breakEvenSoft: 'rgba(34, 211, 238, 0.18)',
      chartPrimary: '#A3E635',
      chartDot: '#D9F99D',
      chartGradientStart: 'rgba(163, 230, 53, 0.32)',
      chartGradientEnd: 'rgba(163, 230, 53, 0.05)',
      chartGrid: '#243126',
      chartTooltipBg: '#0B1016',
      scrollbarTrack: '#121B17',
      scrollbarThumb: '#50674A',
      shadow: 'rgba(5, 7, 10, 0.64)',
      selection: 'rgba(163, 230, 53, 0.3)',
    },
  },
  {
    id: 'laser-rose',
    label: 'Laser Rose',
    family: 'dark',
    tags: ['neon'],
    description: 'Deep plum-black layers with bright rose and cyan contrast.',
    tokens: {
      bg: '#09050D',
      surface: '#120A16',
      surface2: '#1C1124',
      surfaceRaised: '#160C1C',
      text: '#FFF6FE',
      textMuted: '#C6A5C5',
      border: '#3A2142',
      inputBg: '#110915',
      accent: '#F472B6',
      accentHover: '#EC4899',
      accentSoft: 'rgba(244, 114, 182, 0.2)',
      success: '#34D399',
      successSoft: 'rgba(52, 211, 153, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#22D3EE',
      breakEvenSoft: 'rgba(34, 211, 238, 0.18)',
      chartPrimary: '#F472B6',
      chartDot: '#F9A8D4',
      chartGradientStart: 'rgba(244, 114, 182, 0.3)',
      chartGradientEnd: 'rgba(244, 114, 182, 0.05)',
      chartGrid: '#3A2142',
      chartTooltipBg: '#120A16',
      scrollbarTrack: '#1B1122',
      scrollbarThumb: '#75507E',
      shadow: 'rgba(9, 5, 13, 0.64)',
      selection: 'rgba(244, 114, 182, 0.3)',
    },
  },
  {
    id: 'ember-screen',
    label: 'Ember Screen',
    family: 'dark',
    tags: ['warm'],
    description: 'Burnt-amber glow on dark glass without washing out the charts.',
    tokens: {
      bg: '#120B07',
      surface: '#1A120D',
      surface2: '#271912',
      surfaceRaised: '#21150F',
      text: '#FFF7F0',
      textMuted: '#C9A997',
      border: '#4A2D1F',
      inputBg: '#170F0A',
      accent: '#FB923C',
      accentHover: '#F97316',
      accentSoft: 'rgba(251, 146, 60, 0.2)',
      success: '#4ADE80',
      successSoft: 'rgba(74, 222, 128, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#F59E0B',
      breakEvenSoft: 'rgba(245, 158, 11, 0.18)',
      chartPrimary: '#FB923C',
      chartDot: '#FDBA74',
      chartGradientStart: 'rgba(251, 146, 60, 0.3)',
      chartGradientEnd: 'rgba(251, 146, 60, 0.05)',
      chartGrid: '#4A2D1F',
      chartTooltipBg: '#1A120D',
      scrollbarTrack: '#221611',
      scrollbarThumb: '#7D5640',
      shadow: 'rgba(18, 11, 7, 0.64)',
      selection: 'rgba(251, 146, 60, 0.3)',
    },
  },
  {
    id: 'aurora-slate',
    label: 'Aurora Slate',
    family: 'dark',
    tags: ['vibrant'],
    description: 'Cold slate layers with teal-green edge lighting and clean contrast.',
    tokens: {
      bg: '#061012',
      surface: '#0C191C',
      surface2: '#12252A',
      surfaceRaised: '#102024',
      text: '#ECFEFF',
      textMuted: '#97B8BC',
      border: '#214148',
      inputBg: '#0A171A',
      accent: '#2DD4BF',
      accentHover: '#14B8A6',
      accentSoft: 'rgba(45, 212, 191, 0.19)',
      success: '#34D399',
      successSoft: 'rgba(52, 211, 153, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#67E8F9',
      breakEvenSoft: 'rgba(103, 232, 249, 0.18)',
      chartPrimary: '#2DD4BF',
      chartDot: '#5EEAD4',
      chartGradientStart: 'rgba(45, 212, 191, 0.3)',
      chartGradientEnd: 'rgba(45, 212, 191, 0.05)',
      chartGrid: '#214148',
      chartTooltipBg: '#0C191C',
      scrollbarTrack: '#122329',
      scrollbarThumb: '#46757D',
      shadow: 'rgba(6, 16, 18, 0.64)',
      selection: 'rgba(45, 212, 191, 0.28)',
    },
  },
  {
    id: 'phantom-indigo',
    label: 'Phantom Indigo',
    family: 'dark',
    tags: ['vibrant'],
    description: 'Midnight indigo surfaces with crisp electric-blue instrumentation.',
    tokens: {
      bg: '#090E1B',
      surface: '#11172A',
      surface2: '#18223A',
      surfaceRaised: '#141D31',
      text: '#F5F7FF',
      textMuted: '#A8B2D9',
      border: '#273455',
      inputBg: '#0F1525',
      accent: '#7C93FF',
      accentHover: '#5D77F6',
      accentSoft: 'rgba(124, 147, 255, 0.2)',
      success: '#34D399',
      successSoft: 'rgba(52, 211, 153, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#38BDF8',
      breakEvenSoft: 'rgba(56, 189, 248, 0.18)',
      chartPrimary: '#7C93FF',
      chartDot: '#A5B4FC',
      chartGradientStart: 'rgba(124, 147, 255, 0.3)',
      chartGradientEnd: 'rgba(124, 147, 255, 0.05)',
      chartGrid: '#273455',
      chartTooltipBg: '#11172A',
      scrollbarTrack: '#151D31',
      scrollbarThumb: '#596C9F',
      shadow: 'rgba(9, 14, 27, 0.64)',
      selection: 'rgba(124, 147, 255, 0.28)',
    },
  },
  {
    id: 'graphite',
    label: 'Graphite',
    family: 'dark',
    tags: [],
    description: 'A neutral dark theme without the blue cast.',
    tokens: {
      bg: '#111111',
      surface: '#1B1B1B',
      surface2: '#262626',
      surfaceRaised: '#202020',
      text: '#F5F5F5',
      textMuted: '#A3A3A3',
      border: '#3F3F46',
      inputBg: '#1D1D1D',
      accent: '#A1A1AA',
      accentHover: '#D4D4D8',
      accentSoft: 'rgba(161, 161, 170, 0.16)',
      success: '#4ADE80',
      successSoft: 'rgba(74, 222, 128, 0.16)',
      loss: '#FB7185',
      lossSoft: 'rgba(251, 113, 133, 0.16)',
      breakEven: '#94A3B8',
      breakEvenSoft: 'rgba(148, 163, 184, 0.16)',
      chartPrimary: '#D4D4D8',
      chartDot: '#E4E4E7',
      chartGradientStart: 'rgba(212, 212, 216, 0.22)',
      chartGradientEnd: 'rgba(212, 212, 216, 0.05)',
      chartGrid: '#3F3F46',
      chartTooltipBg: '#1B1B1B',
      scrollbarTrack: '#262626',
      scrollbarThumb: '#6B7280',
      shadow: 'rgba(0, 0, 0, 0.56)',
      selection: 'rgba(212, 212, 216, 0.2)',
    },
  },
];

const THEMES_BY_ID = Object.fromEntries(THEME_DEFINITIONS.map((theme) => [theme.id, theme]));
const BASE_THEME_IDS = new Set(['light', 'dark']);
export const DEFAULT_THEME_ID = 'true-black';
const READABLE_DARK_TEXT = '#111827';
const READABLE_LIGHT_TEXT = '#f9fafb';

function toCssVarName(tokenKey) {
  return `--theme-${tokenKey
    .replace(/([a-z])(\d)/g, '$1-$2')
    .replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`)}`;
}

function clampChannel(value) {
  return Math.max(0, Math.min(255, Math.round(value)));
}

function hexToRgb(color) {
  const sanitized = sanitizeHexColor(color);
  if (!sanitized) {
    return null;
  }

  const numeric = Number.parseInt(sanitized.slice(1), 16);
  if (!Number.isFinite(numeric)) {
    return null;
  }

  return {
    red: (numeric >> 16) & 255,
    green: (numeric >> 8) & 255,
    blue: numeric & 255,
  };
}

function rgbToHex({ red, green, blue }) {
  const toHex = (value) => clampChannel(value).toString(16).padStart(2, '0');
  return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
}

function mixHexColors(sourceColor, targetColor, ratio) {
  const source = hexToRgb(sourceColor);
  const target = hexToRgb(targetColor);

  if (!source || !target) {
    return sanitizeHexColor(sourceColor) || sourceColor;
  }

  const normalizedRatio = Math.max(0, Math.min(1, ratio));

  return rgbToHex({
    red: source.red + (target.red - source.red) * normalizedRatio,
    green: source.green + (target.green - source.green) * normalizedRatio,
    blue: source.blue + (target.blue - source.blue) * normalizedRatio,
  });
}

function shiftHexColor(color, amount) {
  const normalizedColor = sanitizeHexColor(color);
  if (!normalizedColor) {
    return color;
  }

  if (amount === 0) {
    return normalizedColor;
  }

  return amount > 0
    ? mixHexColors(normalizedColor, '#ffffff', amount)
    : mixHexColors(normalizedColor, '#000000', Math.abs(amount));
}

function getRelativeLuminance(color) {
  const rgb = hexToRgb(color);

  if (!rgb) {
    return 0;
  }

  const channels = [rgb.red, rgb.green, rgb.blue].map((value) => {
    const normalized = value / 255;
    return normalized <= 0.03928
      ? normalized / 12.92
      : ((normalized + 0.055) / 1.055) ** 2.4;
  });

  return (0.2126 * channels[0]) + (0.7152 * channels[1]) + (0.0722 * channels[2]);
}

function getContrastRatio(backgroundColor, foregroundColor) {
  const backgroundLuminance = getRelativeLuminance(backgroundColor);
  const foregroundLuminance = getRelativeLuminance(foregroundColor);
  const lighter = Math.max(backgroundLuminance, foregroundLuminance);
  const darker = Math.min(backgroundLuminance, foregroundLuminance);

  return (lighter + 0.05) / (darker + 0.05);
}

function getReadableTextProfile(backgroundColor) {
  const lightContrast = getContrastRatio(backgroundColor, READABLE_LIGHT_TEXT);
  const darkContrast = getContrastRatio(backgroundColor, READABLE_DARK_TEXT);
  const useLightText = lightContrast > darkContrast;

  return {
    family: useLightText ? 'dark' : 'light',
    text: useLightText ? READABLE_LIGHT_TEXT : READABLE_DARK_TEXT,
  };
}

function deriveBackgroundTokens(backgroundColor) {
  const normalizedBackground = sanitizeHexColor(backgroundColor);

  if (!normalizedBackground) {
    return null;
  }

  const { family, text } = getReadableTextProfile(normalizedBackground);
  const isDarkTheme = family === 'dark';
  const textMuted = mixHexColors(text, normalizedBackground, isDarkTheme ? 0.34 : 0.58);
  const border = mixHexColors(text, normalizedBackground, isDarkTheme ? 0.74 : 0.84);
  const surface = shiftHexColor(normalizedBackground, isDarkTheme ? 0.08 : 0.04);
  const surface2 = shiftHexColor(normalizedBackground, isDarkTheme ? 0.14 : -0.06);
  const surfaceRaised = shiftHexColor(normalizedBackground, isDarkTheme ? 0.18 : 0.09);
  const inputBg = shiftHexColor(normalizedBackground, isDarkTheme ? 0.1 : 0.07);
  const chartGrid = mixHexColors(border, normalizedBackground, isDarkTheme ? 0.18 : 0.22);
  const chartTooltipBg = surfaceRaised;
  const scrollbarTrack = shiftHexColor(normalizedBackground, isDarkTheme ? 0.06 : -0.04);
  const scrollbarThumb = mixHexColors(text, normalizedBackground, isDarkTheme ? 0.58 : 0.72);
  const shadow = isDarkTheme ? 'rgba(2, 6, 23, 0.42)' : 'rgba(15, 23, 42, 0.12)';

  return {
    family,
    tokens: {
      bg: normalizedBackground,
      surface,
      surface2,
      surfaceRaised,
      text,
      textMuted,
      border,
      inputBg,
      chartGrid,
      chartTooltipBg,
      scrollbarTrack,
      scrollbarThumb,
      shadow,
    },
  };
}

function deriveAccentTokens(theme, accentColor) {
  const isDarkTheme = theme.family === 'dark';
  const normalizedAccent = sanitizeHexColor(accentColor);

  if (!normalizedAccent) {
    return {};
  }

  const accentHover = shiftHexColor(normalizedAccent, isDarkTheme ? -0.14 : -0.16);
  const chartDot = shiftHexColor(normalizedAccent, isDarkTheme ? 0.18 : 0.12);
  const softAlpha = isDarkTheme ? 0.18 : 0.13;
  const gradientStartAlpha = isDarkTheme ? 0.28 : 0.22;
  const gradientEndAlpha = isDarkTheme ? 0.05 : 0.03;
  const selectionAlpha = isDarkTheme ? 0.28 : 0.22;

  return {
    accent: normalizedAccent,
    accentHover,
    accentSoft: withAlpha(normalizedAccent, softAlpha),
    breakEven: normalizedAccent,
    breakEvenSoft: withAlpha(normalizedAccent, softAlpha),
    chartPrimary: normalizedAccent,
    chartDot,
    chartGradientStart: withAlpha(normalizedAccent, gradientStartAlpha),
    chartGradientEnd: withAlpha(normalizedAccent, gradientEndAlpha),
    selection: withAlpha(normalizedAccent, selectionAlpha),
  };
}

function resolveAccentInput(themeId, accentOverrides) {
  if (typeof accentOverrides === 'string') {
    return sanitizeHexColor(accentOverrides);
  }

  if (!accentOverrides || typeof accentOverrides !== 'object' || Array.isArray(accentOverrides)) {
    return null;
  }

  return sanitizeHexColor(accentOverrides[themeId]);
}

function resolveBackgroundInput(themeId, backgroundOverrides) {
  if (typeof backgroundOverrides === 'string') {
    return sanitizeHexColor(backgroundOverrides);
  }

  if (!backgroundOverrides || typeof backgroundOverrides !== 'object' || Array.isArray(backgroundOverrides)) {
    return null;
  }

  return sanitizeHexColor(backgroundOverrides[themeId]);
}

function resolveTextInput(themeId, textOverrides) {
  if (typeof textOverrides === 'string') {
    return sanitizeHexColor(textOverrides);
  }

  if (!textOverrides || typeof textOverrides !== 'object' || Array.isArray(textOverrides)) {
    return null;
  }

  return sanitizeHexColor(textOverrides[themeId]);
}

export function sanitizeHexColor(color) {
  if (typeof color !== 'string') {
    return null;
  }

  const trimmed = color.trim();
  if (!trimmed.startsWith('#')) {
    return null;
  }

  const hex = trimmed.slice(1);
  if (/^[0-9a-fA-F]{3}$/.test(hex)) {
    return `#${hex.split('').map((char) => `${char}${char}`).join('').toLowerCase()}`;
  }

  if (/^[0-9a-fA-F]{6}$/.test(hex)) {
    return `#${hex.toLowerCase()}`;
  }

  return null;
}

export function sanitizeThemeAccentOverrides(value) {
  return sanitizeThemeColorOverrides(value);
}

export function sanitizeThemeBackgroundOverrides(value) {
  return sanitizeThemeColorOverrides(value);
}

export function sanitizeThemeTextOverrides(value) {
  return sanitizeThemeColorOverrides(value);
}

function sanitizeThemeColorOverrides(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }

  return Object.keys(value)
    .sort()
    .reduce((accumulator, themeId) => {
      if (!THEMES_BY_ID[themeId]) {
        return accumulator;
      }

      const sanitizedColor = sanitizeHexColor(value[themeId]);
      if (sanitizedColor) {
        accumulator[themeId] = sanitizedColor;
      }

      return accumulator;
    }, {});
}

export function getThemeById(themeId) {
  return THEMES_BY_ID[themeId] || THEMES_BY_ID[DEFAULT_THEME_ID];
}

export function getResolvedTheme(
  themeId,
  accentOverrides = {},
  backgroundOverrides = {},
  textOverrides = {},
  outcomeColorOverrides = {}
) {
  const theme = getThemeById(themeId);
  const accentOverride = resolveAccentInput(theme.id, accentOverrides);
  const backgroundOverride = resolveBackgroundInput(theme.id, backgroundOverrides);
  const textOverride = resolveTextInput(theme.id, textOverrides);
  const backgroundProfile = backgroundOverride ? deriveBackgroundTokens(backgroundOverride) : null;
  const family = backgroundProfile?.family || theme.family;
  const backgroundTokens = backgroundProfile?.tokens || {};
  const effectiveBackground = backgroundTokens.bg || theme.tokens.bg;
  const textTokens = textOverride
    ? {
      text: textOverride,
      textMuted: mixHexColors(textOverride, effectiveBackground, family === 'dark' ? 0.34 : 0.58),
    }
    : null;
  const baseTheme = backgroundProfile
    ? {
      ...theme,
      family,
      tokens: {
        ...theme.tokens,
        ...backgroundTokens,
      },
    }
    : theme;
  const baseTokens = textTokens
    ? {
      ...baseTheme.tokens,
      ...textTokens,
    }
    : baseTheme.tokens;
  const accentResolvedTokens = accentOverride
    ? {
      ...baseTokens,
      ...deriveAccentTokens(baseTheme, accentOverride),
    }
    : baseTokens;
  const successOverride = sanitizeHexColor(
    outcomeColorOverrides.success || outcomeColorOverrides.winColor
  );
  const lossOverride = sanitizeHexColor(
    outcomeColorOverrides.loss || outcomeColorOverrides.lossColor
  );
  const resolvedTokens = {
    ...accentResolvedTokens,
    ...(successOverride
      ? {
        success: successOverride,
        successSoft: withAlpha(successOverride, family === 'dark' ? 0.16 : 0.14),
      }
      : {}),
    ...(lossOverride
      ? {
        loss: lossOverride,
        lossSoft: withAlpha(lossOverride, family === 'dark' ? 0.16 : 0.14),
      }
      : {}),
  };

  return {
    ...baseTheme,
    accentOverride: accentOverride || null,
    backgroundOverride,
    textOverride,
    tokens: {
      ...resolvedTokens,
      accentText: getReadableTextProfile(resolvedTokens.accent).text,
    },
  };
}

export function getThemeFamily(themeId) {
  return getThemeById(themeId).family;
}

export function getThemeAccentOverride(themeId, accentOverrides = {}) {
  return resolveAccentInput(themeId, accentOverrides);
}

export function getThemeBackgroundOverride(themeId, backgroundOverrides = {}) {
  return resolveBackgroundInput(themeId, backgroundOverrides);
}

export function getThemeTextOverride(themeId, textOverrides = {}) {
  return resolveTextInput(themeId, textOverrides);
}

export function resolveThemeId(themeId, legacyTheme) {
  if (themeId && THEMES_BY_ID[themeId]) {
    return themeId;
  }

  if (legacyTheme === 'dark' || legacyTheme === 'light') {
    return legacyTheme;
  }

  return DEFAULT_THEME_ID;
}

export function getBaseThemeIdForFamily(family) {
  return family === 'dark' ? 'dark' : 'light';
}

export function isBaseThemeId(themeId) {
  return BASE_THEME_IDS.has(themeId);
}

export function getThemeStorageValue(themeId, accentOverrides = {}, backgroundOverrides = {}, textOverrides = {}) {
  const theme = getThemeById(themeId);

  return {
    themeId: theme.id,
    theme: theme.family,
    themeAccentOverrides: sanitizeThemeAccentOverrides(accentOverrides),
    themeBackgroundOverrides: sanitizeThemeBackgroundOverrides(backgroundOverrides),
    themeTextOverrides: sanitizeThemeTextOverrides(textOverrides),
  };
}

// Minimum contrast (vs bg, surface, surface-2) for colours the UI uses as text.
const CONTRAST_TARGETS = {
  // Margin over AA (4.5) because these are also used on their own tinted "-soft" backgrounds.
  accent: 5.6,
  accentHover: 4.6,
  success: 5.6,
  loss: 5.6,
  breakEven: 5.6,
  textMuted: 5.8,
};

function ensureContrast(color, backgrounds, target, towards) {
  const base = sanitizeHexColor(color);
  if (!base || !backgrounds.length) return color;
  const worst = (candidate) => Math.min(...backgrounds.map((background) => getContrastRatio(background, candidate)));
  for (let step = 0; step <= 20; step += 1) {
    const candidate = mixHexColors(base, towards, step * 0.04);
    if (worst(candidate) >= target) return candidate;
  }
  return mixHexColors(base, towards, 0.8);
}

export function applyThemeToDocument(
  themeId,
  accentOverrides = {},
  backgroundOverrides = {},
  textOverrides = {},
  outcomeColorOverrides = {}
) {
  if (typeof document === 'undefined') {
    return;
  }

  const resolvedTheme = getResolvedTheme(
    themeId,
    accentOverrides,
    backgroundOverrides,
    textOverrides,
    outcomeColorOverrides
  );
  const root = document.documentElement;
  const adjusted = {};
  const tokens = resolvedTheme.tokens;
  const backdrops = [tokens.bg, tokens.surface, tokens.surface2, tokens.surfaceRaised].filter(Boolean);

  root.dataset.theme = resolvedTheme.id;
  root.classList.toggle('dark', resolvedTheme.family === 'dark');

  Object.entries(resolvedTheme.tokens).forEach(([tokenKey, tokenValue]) => {
    root.style.setProperty(toCssVarName(tokenKey), tokenValue);
    // Space-separated RGB channels let Tailwind's semantic colours support
    // opacity modifiers, e.g. `bg-accent/10` -> rgb(var(--theme-accent-rgb) / 0.1).
    // Text-capable colours are nudged (toward black on light themes, white on dark) until they
    // meet WCAG AA against the theme's own surfaces. Only the Tailwind channels are adjusted:
    // the raw --theme-* hex variables (charts, calendar cards) keep the designer's colour.
    const target = CONTRAST_TARGETS[tokenKey];
    const channelColor = target
      ? ensureContrast(tokenValue, backdrops, target, resolvedTheme.family === 'dark' ? '#ffffff' : '#000000')
      : tokenValue;
    const rgb = hexToRgb(channelColor);
    if (rgb) {
      root.style.setProperty(`${toCssVarName(tokenKey)}-rgb`, `${rgb.red} ${rgb.green} ${rgb.blue}`);
    }
    adjusted[tokenKey] = channelColor;
  });
  // Warning amber is not a theme token; derive it per theme with the same contrast rule.
  const warn = ensureContrast(
    resolvedTheme.family === 'dark' ? '#f59e0b' : '#d97706',
    backdrops,
    5.6,
    resolvedTheme.family === 'dark' ? '#ffffff' : '#000000'
  );
  const warnRgb = hexToRgb(warn);
  if (warnRgb) root.style.setProperty('--theme-warn-rgb', `${warnRgb.red} ${warnRgb.green} ${warnRgb.blue}`);

  [['accent', 'accent-text'], ['loss', 'loss-fg'], ['success', 'success-fg']].forEach(([key, name]) => {
    const readable = hexToRgb(getReadableTextProfile(adjusted[key] || resolvedTheme.tokens[key]).text);
    if (readable) root.style.setProperty(`--theme-${name}-rgb`, `${readable.red} ${readable.green} ${readable.blue}`);
  });
}

export function withAlpha(color, alpha) {
  if (typeof color !== 'string') {
    return color;
  }

  const normalizedAlpha = Math.max(0, Math.min(1, alpha));
  const trimmed = color.trim();

  if (trimmed.startsWith('#')) {
    const hex = trimmed.slice(1);
    const expanded = hex.length === 3
      ? hex.split('').map((char) => char + char).join('')
      : hex;

    if (expanded.length !== 6) {
      return color;
    }

    const parsed = Number.parseInt(expanded, 16);
    if (!Number.isFinite(parsed)) {
      return color;
    }

    const red = (parsed >> 16) & 255;
    const green = (parsed >> 8) & 255;
    const blue = parsed & 255;
    return `rgba(${red}, ${green}, ${blue}, ${normalizedAlpha})`;
  }

  if (trimmed.startsWith('rgb(')) {
    return trimmed.replace('rgb(', 'rgba(').replace(')', `, ${normalizedAlpha})`);
  }

  if (trimmed.startsWith('rgba(')) {
    return trimmed.replace(/rgba\(([^)]+),\s*[\d.]+\)/, `rgba($1, ${normalizedAlpha})`);
  }

  return color;
}

export const CURATED_THEME_IDS = [
  'light',
  'paper',
  'mint-light',
  'volt',
  'sunset-pop',
  'dark',
  'true-black',
  'midnight-blue',
  'forest-dark',
  'neon-market',
];

const CURATED_THEME_ID_SET = new Set(CURATED_THEME_IDS);

// Keep the complete definitions available for existing saved preferences while
// presenting a smaller, deliberately distinct library to choose from.
export const THEMES = THEME_DEFINITIONS.filter((theme) => CURATED_THEME_ID_SET.has(theme.id));
